export default __webpack_public_path__ + "static/media/4797aa63e60d0b4c5b77dc439f7263b71598916969229.1fbefda2.webp";